import React from 'react';
import { Card, CardContent, Box, Typography } from '@mui/material';
import { brand } from '../../theme';

interface StatCardProps {
  label: string;
  value: React.ReactNode;
  icon: React.ReactElement;
  /** icon tint; defaults to brand orange */
  color?: string;
  sub?: string;
}

/** Reusable KPI tile for the admin dashboard (icon + label + big value). */
const StatCard: React.FC<StatCardProps> = ({ label, value, icon, color = brand.orange, sub }) => (
  <Card sx={{ height: '100%' }}>
    <CardContent>
      <Box display="flex" alignItems="center" gap={2}>
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: `${color}1A`,
            color,
            flexShrink: 0,
          }}
        >
          {icon}
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="body2" color="text.secondary" noWrap>
            {label}
          </Typography>
          <Typography variant="h5" fontWeight={700} lineHeight={1.2}>
            {value}
          </Typography>
          {sub && (
            <Typography variant="caption" color="text.secondary">
              {sub}
            </Typography>
          )}
        </Box>
      </Box>
    </CardContent>
  </Card>
);

export default StatCard;
